import {Component, Input, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {FileUpload} from "./file-upload";
import {FileUploadService} from "./upload.service";

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss']
})
export class ImageUploadComponent implements OnDestroy {
  private _destroyed$ = new Subject<void>();

  @Input() pathToDatabase: string | undefined
  @Input() dbType?: string = 'realtime'
  @Input() storagePath?: string = 'uploads/'
  @Input() uploadWithTitle?: boolean = true
  @Input() title?: string = ""
  @Input() addToArray = false
  selectedFiles!: FileList;
  currentFileUpload!: FileUpload;
  percentage!: number;


  constructor(private uploadService: FileUploadService) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  // @ts-ignore
  selectFile(event): void {
    this.selectedFiles = event.target.files;
  }

  upload(): void {
    const file = this.selectedFiles.item(0);
    // @ts-ignore
    this.selectedFiles = undefined;

    // @ts-ignore
    this.currentFileUpload = new FileUpload(file);
    if (this.storagePath != 'uploads/') {
      if (this.title != '') this.currentFileUpload.fileName = this.title||""
      this.uploadService.pushFileToStorageWith(this.currentFileUpload, this.pathToDatabase, this.dbType!, this.storagePath!, this.addToArray).pipe(takeUntil(this._destroyed$)).subscribe(
        percentage => {
          this.percentage = Math.round(percentage);
        },
        error => {
          console.log(error);
        }
      );


    } else if (this.storagePath == 'uploads/') {
      this.uploadService.pushFileToStorage(this.currentFileUpload, this.pathToDatabase, this.dbType!).pipe(takeUntil(this._destroyed$)).subscribe(
        percentage => {
          this.percentage = Math.round(percentage);
        },
        error => {
          console.log(error);
        }
      );
    }
  }
}
